import React, { PureComponent } from "react";
import { ErrorMessage, Form, Formik } from "formik";
import { object, string, array, boolean } from "yup";
import * as Yup from "yup";
import { Button, Checkbox, Dropdown, Grid, Input, Label } from "semantic-ui-react";
import { isEmpty, get } from "lodash";

export class UserForm extends PureComponent {
  render() {
    const { tenants, user, edit } = this.props;
    return (
      <>
        <Formik
          enableReinitialize
          validateOnChange
          initialValues={{
            firstName: get(user, "firstName", ""),
            lastName: get(user, "lastName", ""),
            email: get(user, "email", ""),
            password: "",
            admin: get(user, "admin", false),
            tenants: get(user, "tenant.id", edit ? "" : [])
          }}
          validationSchema={object().shape({
            firstName: string()
              .required("First name is required!")
              .min(3, "More characters required!"),
            lastName: string()
              .required("Last name is required!")
              .min(3, "More characters required!"),
            email: Yup.string()
              .email("Invalid email")
              .required("Email is required!"),
            password:
              edit === true
                ? Yup.string()
                : Yup.string()
                    .required("Password is required!")
                    .min(3, "More characters required!"),
            admin: boolean(),
            tenants:
              edit === true
                ? string().when(
                    "admin",
                    {
                      is: false,
                      then: string()
                        .min(1, "Please select at least one tenant if the user is not of Super Admin type!")
                        .required("Required!")
                    },
                    {
                      is: true,
                      then: string()
                    }
                  )
                : array().when(
                    "admin",
                    {
                      is: false,
                      then: array()
                        .min(1, "Please select at least one tenant if the user is not of Super Admin type!")
                        .required("Required!")
                    },
                    {
                      is: true,
                      then: array()
                    }
                  )
          })}
          onSubmit={(values, { setSubmitting }) => {
            this.props.onSubmit(values);
            setSubmitting(false);
          }}
        >
          {({ dirty, errors, handleBlur, isSubmitting, isValid, setFieldValue, touched, values }) => (
            <Form widths="equal">
              <Grid padded>
                <Grid.Row>
                  <h3>{edit ? "Edit user" : "Add new user"}</h3>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column verticalAlign="middle" width={4}>
                    <h4>First name</h4>
                  </Grid.Column>
                  <Grid.Column width={4} stretched textAlign="center">
                    <Input
                      value={values.firstName}
                      onChange={(e, data) => setFieldValue("firstName", data.value)}
                      fluid
                      name="firstName"
                      placeholder="First name"
                      data-test="firstname"
                      onBlur={handleBlur}
                      icon="user"
                      iconPosition="left"
                    />
                    <ErrorMessage name="firstName" component={Label} basic pointing color="red" />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column verticalAlign="middle" width={4}>
                    <h4>Last Name:</h4>
                  </Grid.Column>
                  <Grid.Column width={4} stretched textAlign="center">
                    <Input
                      value={values.lastName}
                      onChange={(e, data) => setFieldValue("lastName", data.value)}
                      fluid
                      name="lastName"
                      placeholder="Last name"
                      data-test="lastname"
                      onBlur={handleBlur}
                      icon="user"
                      iconPosition="left"
                    />
                    <ErrorMessage name="lastName" component={Label} basic pointing color="red" />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column verticalAlign="middle" width={4}>
                    <h4>Email:</h4>
                  </Grid.Column>
                  <Grid.Column width={4} stretched textAlign="center">
                    <Input
                      value={values.email}
                      onChange={(e, data) => setFieldValue("email", data.value)}
                      fluid
                      name="email"
                      type="email"
                      placeholder="Email"
                      data-test="email"
                      onBlur={handleBlur}
                      icon="mail"
                      iconPosition="left"
                    />
                    <ErrorMessage name="email" component={Label} basic pointing color="red" />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column verticalAlign="middle" width={4}>
                    <h4>Password:</h4>
                  </Grid.Column>
                  <Grid.Column width={4} stretched textAlign="center">
                    <Input
                      value={values.password}
                      onChange={(e, data) => setFieldValue("password", data.value)}
                      fluid
                      name="password"
                      type="password"
                      placeholder="Password"
                      data-test="password"
                      onBlur={handleBlur}
                      icon="user secret"
                      iconPosition="left"
                    />
                    <ErrorMessage name="password" component={Label} basic pointing color="red" />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column verticalAlign="middle" width={4}>
                    <h4>Is Super Admin:</h4>
                  </Grid.Column>
                  <Grid.Column width={4} stretched textAlign="center">
                    <Checkbox
                      name="admin"
                      label="If checked, user will have access to all tenants."
                      checked={values.admin}
                      onChange={(e, data) => {
                        setFieldValue("admin", data.checked);
                        if (data.checked === true) {
                          setFieldValue("tenants", edit === true ? "" : []);
                        }
                      }}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column verticalAlign="middle" width={4}>
                    <h4>Has access to tenant</h4>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Dropdown
                      clearable
                      name="tenants"
                      placeholder="Select tenant"
                      fluid
                      multiple={!edit}
                      disabled={values.admin === true}
                      value={values.tenants}
                      onChange={(e, data) => {
                        setFieldValue("tenants", data.value);
                      }}
                      selection
                      options={(tenants || []).map(tenant => ({
                        key: tenant.id,
                        text: `${tenant.name}`,
                        value: tenant.id
                      }))}
                      data-test="discountType"
                      error={touched && !isEmpty(errors.tenants)}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={12}>
                    {values.tenants && values.tenants.length > 1 && !edit && (
                      <p className="warning-text">
                        <b>Warning!</b> <br />
                        Please be aware that selecting access to multiple tenants will not require the entered e-mail address
                        for login but the email with the name of the tenant appended to it. <br /> For example, if your email
                        is <b> george@gmail.com </b> and the selected tenants are <b>Facturis </b>
                        and <b>Billtobox</b>, the required login would then be: <b>george+facturis@gmail.com</b> and
                        <b> george+billtobox@gmail.com </b> respectively.
                      </p>
                    )}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={4} textAlign="right">
                    <Button size="medium" color="orange" content={edit ? "Save" : "Add User"} type="submit" />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          )}
        </Formik>
      </>
    );
  }
}

export default UserForm;
